#import "./SentenceDetails.graphql"
query SentencesBySefariaRangeQuery($firstSefariaId: String!, $lastSefariaId: String!) {
  sentencesBySefariaRange(firstSefariaId: $firstSefariaId, lastSefariaId: $lastSefariaId) {
    ...sentenceDetails
  }
}
